let initialState = {
  allAttributes: null, // set all attributes title and key name
  username: null,
  topThreeReports: null,
  temporary_words: {},
  reach_refresh_time: null,
};
const attributes = (state = initialState, action) => {
  switch (action.type) {
    case "SET_ALL_ATTRIBUTES":
      return {
        ...state,
        allAttributes: action.payload,
      };

    case "SET_USERNAME":
      return {
        ...state,
        username: action.payload,
      };
    case "SET_SIDEBAR_TOP_THREE_REPORTS":
      return {
        ...state,
        topThreeReports: action.payload,
      };
    case "SET_TEMPORARY_WORDS":
      return {
        ...state,
        temporary_words: action.payload,
      };
    case "SET_REACH_REFRESH_TIME":
      return {
        ...state,
        reach_refresh_time: action.payload,
      };
    default:
      return state;
  }
};

export default attributes;
